import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-arkansas-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./arkansas-state-form.component.html",
  styleUrl: "./arkansas-state-form.component.scss",
})
export class ArkansasStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
